export default function VerificationStatus({ status }) {
  return (
    <>
      {status == "Approved" && (
        <span className="inline-flex items-center justify-center gap-1 rounded-full bg-success-500 px-2.5 py-0.5 text-sm font-medium text-white">
          Approved
        </span>
      )}

      {status == "Declined" && (
        <span className="inline-flex items-center justify-center gap-1 rounded-full bg-error-500 px-2.5 py-0.5 text-sm font-medium text-white">
          Declined
        </span>
      )}

      {status == "In Review" && (
        <span className="inline-flex items-center justify-center gap-1 rounded-full bg-brand-500 px-2.5 py-0.5 text-sm font-medium text-white">
          In Review
        </span>
      )}

      {status == "In Progress" && (
        <span className="inline-flex items-center justify-center gap-1 rounded-full bg-blue-light-500 px-2.5 py-0.5 text-sm font-medium text-white">
          In Progress
        </span>
      )}

      {status == "Expired" && (
        <span className="inline-flex items-center justify-center gap-1 rounded-full bg-warning-500 px-2.5 py-0.5 text-sm font-medium text-white">
          Expired
        </span>
      )}

      {status == "Abandoned" && (
        <span className="inline-flex items-center justify-center gap-1 rounded-full bg-gray-400 px-2.5 py-0.5 text-sm font-medium text-white dark:bg-white/5 dark:text-white/80">
          Abandoned
        </span>
      )}
    </>
  );
}
